import { Component } from '@angular/core';
import {environment} from '../../../../environments/environment';

@Component({
  selector: 'app-for-development',
  templateUrl: './for-development.component.html',
  styleUrl: './for-development.component.scss'
})
export class ForDevelopmentComponent {

  isDevelopmentMode() {
    // Check if the environment version includes 'dev' or 'default'
    // return environment.version.includes('dev') || environment.version.includes('default');
    return environment.version.includes('default');
  }
}
